import { render, staticRenderFns } from "./BrandLogoLoader.vue?vue&type=template&id=170c593c&scoped=true&"
import script from "./BrandLogoLoader.vue?vue&type=script&lang=js&"
export * from "./BrandLogoLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c593c",
  null
  
)

export default component.exports